import { useMemo, useState } from 'react';
import { BillingCycle, IProductEntity } from '@/features/common/pricing';

import { PricingUseCase } from '../domain/PricingUseCase';

export const usePricingPageViewModel = ({
  products,
}: {
  products: IProductEntity[];
}): {
  billingCycle: BillingCycle.Monthly | BillingCycle.Yearly;
  productsMetadata: ReturnType<PricingUseCase['getProductsMetadata']>;
  maxAnnualDiscount: number;
  onChangeBillingCycle: (cycle: BillingCycle.Monthly | BillingCycle.Yearly) => void;
} => {
  const [billingCycle, setBillingCycle] = useState<
    BillingCycle.Monthly | BillingCycle.Yearly
  >(BillingCycle.Yearly);
  const [pricingUseCase] = useState(() => new PricingUseCase());

  const productsMetadata = useMemo(
    () => pricingUseCase.getProductsMetadata(products, billingCycle),
    [products, billingCycle, pricingUseCase],
  );

  const maxAnnualDiscount = useMemo(
    () => Math.max(...productsMetadata.map((p) => p.annualDiscount)),
    [productsMetadata],
  );

  return {
    billingCycle,
    productsMetadata,
    maxAnnualDiscount,
    onChangeBillingCycle: setBillingCycle,
  };
};
